import { default as claim_45received_46specjxtwGwVVBWMeta } from "/app/apps/concierge/src/pages/claim-received.spec.js?macro=true";
import { default as claim_45receivedtA7zrOAMLAMeta } from "/app/apps/concierge/src/pages/claim-received.vue?macro=true";
import { default as indexMyJBCfqNzUMeta } from "/app/apps/concierge/src/pages/in-store/claim-type/index.vue?macro=true";
import { default as claim_45type1tH24uBQ0DMeta } from "/app/apps/concierge/src/pages/in-store/claim-type.vue?macro=true";
import { default as index_46specMpnnOViGwOMeta } from "/app/apps/concierge/src/pages/in-store/contact-info/index.spec.js?macro=true";
import { default as indexCkO8MIMQepMeta } from "/app/apps/concierge/src/pages/in-store/contact-info/index.vue?macro=true";
import { default as contact_45infoE1QbxPQPlbMeta } from "/app/apps/concierge/src/pages/in-store/contact-info.vue?macro=true";
import { default as index_46spec0AEOhpWjN5Meta } from "/app/apps/concierge/src/pages/in-store/date-of-purchase/index.spec.js?macro=true";
import { default as indexhdYcLed0biMeta } from "/app/apps/concierge/src/pages/in-store/date-of-purchase/index.vue?macro=true";
import { default as date_45of_45purchasedkVr3rQxkvMeta } from "/app/apps/concierge/src/pages/in-store/date-of-purchase.vue?macro=true";
import { default as ai_45product_45finder_46spec70paIbRfWfMeta } from "/app/apps/concierge/src/pages/in-store/products/ai-product-finder.spec.js?macro=true";
import { default as close_45match_45modal_46specY1uOL2FuA8Meta } from "/app/apps/concierge/src/pages/in-store/products/close-match-modal.spec.js?macro=true";
import { default as close_45match_46specUR8NrXEBHEMeta } from "/app/apps/concierge/src/pages/in-store/products/close-match.spec.js?macro=true";
import { default as index_46spectD15h05FdMMeta } from "/app/apps/concierge/src/pages/in-store/products/index.spec.js?macro=true";
import { default as indexoSamL5dG7OMeta } from "/app/apps/concierge/src/pages/in-store/products/index.vue?macro=true";
import { default as index_46spec1XcAoLicwjMeta } from "/app/apps/concierge/src/pages/in-store/products/not-found/index.spec.js?macro=true";
import { default as indexXxVIvVMOljMeta } from "/app/apps/concierge/src/pages/in-store/products/not-found/index.vue?macro=true";
import { default as product_45not_45found_45form_46spec86ZulEHZi8Meta } from "/app/apps/concierge/src/pages/in-store/products/product-not-found-form.spec.js?macro=true";
import { default as productskftfBxuZWaMeta } from "/app/apps/concierge/src/pages/in-store/products.vue?macro=true";
import { default as index_46specGfhVm1segXMeta } from "/app/apps/concierge/src/pages/in-store/receipt/index.spec.js?macro=true";
import { default as indexE2JSrHICpJMeta } from "/app/apps/concierge/src/pages/in-store/receipt/index.vue?macro=true";
import { default as index_46specusI6AOw6shMeta } from "/app/apps/concierge/src/pages/in-store/receipt/required/index.spec.js?macro=true";
import { default as indexxU8B17mUGAMeta } from "/app/apps/concierge/src/pages/in-store/receipt/required/index.vue?macro=true";
import { default as index_46specsjcgTUE00LMeta } from "/app/apps/concierge/src/pages/in-store/receipt/upload/index.spec.js?macro=true";
import { default as indexPiPUogZGw5Meta } from "/app/apps/concierge/src/pages/in-store/receipt/upload/index.vue?macro=true";
import { default as receiptqXVH1zaSo3Meta } from "/app/apps/concierge/src/pages/in-store/receipt.vue?macro=true";
import { default as index7kwq96cxT3Meta } from "/app/apps/concierge/src/pages/in-store/resolution/index.vue?macro=true";
import { default as resolutionNnLUXJzuxwMeta } from "/app/apps/concierge/src/pages/in-store/resolution.vue?macro=true";
import { default as index_46spec36MaY3ZjAGMeta } from "/app/apps/concierge/src/pages/in-store/review/index.spec.js?macro=true";
import { default as indexIKepb970L5Meta } from "/app/apps/concierge/src/pages/in-store/review/index.vue?macro=true";
import { default as reviewSLW2cf9QkQMeta } from "/app/apps/concierge/src/pages/in-store/review.vue?macro=true";
import { default as indexZBF4ZB2EcIMeta } from "/app/apps/concierge/src/pages/in-store/sales-channel/index.vue?macro=true";
import { default as sales_45channelon7VY9o0s5Meta } from "/app/apps/concierge/src/pages/in-store/sales-channel.vue?macro=true";
import { default as index_46spec7qFFL2UkoTMeta } from "/app/apps/concierge/src/pages/in-store/shipping-address/index.spec.js?macro=true";
import { default as indexnIViEN2jLPMeta } from "/app/apps/concierge/src/pages/in-store/shipping-address/index.vue?macro=true";
import { default as shipping_45addressV0NtiW5E3SMeta } from "/app/apps/concierge/src/pages/in-store/shipping-address.vue?macro=true";
import { default as uploadyn5FoRv4yoMeta } from "/app/apps/concierge/src/pages/in-store/upload.vue?macro=true";
import { default as index_46specIWek603zjSMeta } from "/app/apps/concierge/src/pages/index.spec.js?macro=true";
import { default as indexRcFS2qQuICMeta } from "/app/apps/concierge/src/pages/index.vue?macro=true";
import { default as issues_46specHVTV4dsJ3QMeta } from "/app/apps/concierge/src/pages/issues.spec.js?macro=true";
import { default as index_46specM8vyosDx74Meta } from "/app/apps/concierge/src/pages/issues/index.spec.js?macro=true";
import { default as indexmRa9T7Az1zMeta } from "/app/apps/concierge/src/pages/issues/index.vue?macro=true";
import { default as items_46speciTSJnQNVNtMeta } from "/app/apps/concierge/src/pages/issues/items.spec.js?macro=true";
import { default as itemsSebbLmbLe1Meta } from "/app/apps/concierge/src/pages/issues/items.vue?macro=true";
import { default as shipment_46specoNQRKC5NOdMeta } from "/app/apps/concierge/src/pages/issues/shipment.spec.js?macro=true";
import { default as details_46specicaZjB1zm8Meta } from "/app/apps/concierge/src/pages/issues/shipment/details.spec.js?macro=true";
import { default as detailsBKlJcXYpm2Meta } from "/app/apps/concierge/src/pages/issues/shipment/details.vue?macro=true";
import { default as index_46specQ7dha50LT7Meta } from "/app/apps/concierge/src/pages/issues/shipment/index.spec.js?macro=true";
import { default as index7x3su0Y6wWMeta } from "/app/apps/concierge/src/pages/issues/shipment/index.vue?macro=true";
import { default as shipmentIdbapodMXWMeta } from "/app/apps/concierge/src/pages/issues/shipment.vue?macro=true";
import { default as issuesePjfeQqLO9Meta } from "/app/apps/concierge/src/pages/issues.vue?macro=true";
import { default as index_46specRRjZ1lib2YMeta } from "/app/apps/concierge/src/pages/multiple-shipments/index.spec.js?macro=true";
import { default as indexa09j5lhPCzMeta } from "/app/apps/concierge/src/pages/multiple-shipments/index.vue?macro=true";
import { default as not_45shipped_46spec3ZzDbT0zKyMeta } from "/app/apps/concierge/src/pages/not-shipped.spec.js?macro=true";
import { default as not_45shipped3tVt0LXiCaMeta } from "/app/apps/concierge/src/pages/not-shipped.vue?macro=true";
import { default as _91token_93nggH91JHeqMeta } from "/app/apps/concierge/src/pages/print/[token].vue?macro=true";
import { default as process_46specYX49P39FUFMeta } from "/app/apps/concierge/src/pages/process.spec.js?macro=true";
import { default as index_46specx6QOGZy4mBMeta } from "/app/apps/concierge/src/pages/process/index.spec.js?macro=true";
import { default as indexDjt1Hc7AUJMeta } from "/app/apps/concierge/src/pages/process/index.vue?macro=true";
import { default as processmYDWhIdThyMeta } from "/app/apps/concierge/src/pages/process.vue?macro=true";
import { default as resolution_46spec1xnoSwkbwmMeta } from "/app/apps/concierge/src/pages/resolution.spec.js?macro=true";
import { default as index_46spec4yeTcriTjyMeta } from "/app/apps/concierge/src/pages/resolution/index.spec.js?macro=true";
import { default as indexULyiQkaWFCMeta } from "/app/apps/concierge/src/pages/resolution/index.vue?macro=true";
import { default as review_46specN0kD768blVMeta } from "/app/apps/concierge/src/pages/resolution/review.spec.js?macro=true";
import { default as review3w0oaWGzkPMeta } from "/app/apps/concierge/src/pages/resolution/review.vue?macro=true";
import { default as resolutionIN9pafKanIMeta } from "/app/apps/concierge/src/pages/resolution.vue?macro=true";
import { default as return_46specxJbTydzXYkMeta } from "/app/apps/concierge/src/pages/return.spec.js?macro=true";
import { default as returne34PxO4rOMMeta } from "/app/apps/concierge/src/pages/return.vue?macro=true";
import { default as indexoGXiVJ5Z2SMeta } from "/app/apps/concierge/src/pages/sign/[claimId]/index.vue?macro=true";
import { default as start_46specU0cur5m9IMMeta } from "/app/apps/concierge/src/pages/start.spec.js?macro=true";
import { default as startv1reK3iRXPMeta } from "/app/apps/concierge/src/pages/start.vue?macro=true";
import { default as too_45late_46specWRkpk2a9OMMeta } from "/app/apps/concierge/src/pages/too-late.spec.js?macro=true";
import { default as too_45lateQlqdKhfNyrMeta } from "/app/apps/concierge/src/pages/too-late.vue?macro=true";
import { default as too_45soon_46specx4dErUfNnTMeta } from "/app/apps/concierge/src/pages/too-soon.spec.js?macro=true";
import { default as too_45soonafT68D1oYVMeta } from "/app/apps/concierge/src/pages/too-soon.vue?macro=true";
import { default as index_46specgiVwImzkRTMeta } from "/app/apps/concierge/src/pages/view/[token]/index.spec.js?macro=true";
import { default as indexIy8gc4KnuvMeta } from "/app/apps/concierge/src/pages/view/[token]/index.vue?macro=true";
import { default as reviewMFONAVXb9fMeta } from "/app/apps/concierge/src/pages/view/[token]/review.vue?macro=true";
export default [
  {
    name: "claim-received.spec",
    path: "/claim-received.spec",
    component: () => import("/app/apps/concierge/src/pages/claim-received.spec.js").then(m => m.default || m)
  },
  {
    name: "claim-received",
    path: "/claim-received",
    component: () => import("/app/apps/concierge/src/pages/claim-received.vue").then(m => m.default || m)
  },
  {
    name: claim_45type1tH24uBQ0DMeta?.name,
    path: "/in-store/claim-type",
    component: () => import("/app/apps/concierge/src/pages/in-store/claim-type.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-claim-type",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/claim-type/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: contact_45infoE1QbxPQPlbMeta?.name,
    path: "/in-store/contact-info",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-contact-info-index.spec",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-contact-info",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: date_45of_45purchasedkVr3rQxkvMeta?.name,
    path: "/in-store/date-of-purchase",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-date-of-purchase-index.spec",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-date-of-purchase",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: productskftfBxuZWaMeta?.name,
    path: "/in-store/products",
    component: () => import("/app/apps/concierge/src/pages/in-store/products.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-products-ai-product-finder.spec",
    path: "ai-product-finder.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/ai-product-finder.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-products-close-match-modal.spec",
    path: "close-match-modal.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/close-match-modal.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-products-close-match.spec",
    path: "close-match.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/close-match.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-products-index.spec",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-products",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-products-not-found-index.spec",
    path: "not-found/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/not-found/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-products-not-found",
    path: "not-found",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/not-found/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-products-product-not-found-form.spec",
    path: "product-not-found-form.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/product-not-found-form.spec.js").then(m => m.default || m)
  }
]
  },
  {
    name: receiptqXVH1zaSo3Meta?.name,
    path: "/in-store/receipt",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-receipt-index.spec",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-required-index.spec",
    path: "required/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/required/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-required",
    path: "required",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/required/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-upload-index.spec",
    path: "upload/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/upload/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-upload",
    path: "upload",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/upload/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: resolutionNnLUXJzuxwMeta?.name,
    path: "/in-store/resolution",
    component: () => import("/app/apps/concierge/src/pages/in-store/resolution.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-resolution",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/resolution/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: reviewSLW2cf9QkQMeta?.name,
    path: "/in-store/review",
    component: () => import("/app/apps/concierge/src/pages/in-store/review.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-review-index.spec",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/review/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-review",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/review/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: sales_45channelon7VY9o0s5Meta?.name,
    path: "/in-store/sales-channel",
    component: () => import("/app/apps/concierge/src/pages/in-store/sales-channel.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-sales-channel",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/sales-channel/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: shipping_45addressV0NtiW5E3SMeta?.name,
    path: "/in-store/shipping-address",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-shipping-address-index.spec",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-shipping-address",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "in-store-upload",
    path: "/in-store/upload",
    component: () => import("/app/apps/concierge/src/pages/in-store/upload.vue").then(m => m.default || m)
  },
  {
    name: "index.spec",
    path: "/index.spec",
    component: () => import("/app/apps/concierge/src/pages/index.spec.js").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/concierge/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "issues.spec",
    path: "/issues.spec",
    component: () => import("/app/apps/concierge/src/pages/issues.spec.js").then(m => m.default || m)
  },
  {
    name: issuesePjfeQqLO9Meta?.name,
    path: "/issues",
    component: () => import("/app/apps/concierge/src/pages/issues.vue").then(m => m.default || m),
    children: [
  {
    name: "issues-index.spec",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/index.spec.js").then(m => m.default || m)
  },
  {
    name: "issues",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/issues/index.vue").then(m => m.default || m)
  },
  {
    name: "issues-items.spec",
    path: "items.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/items.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-items",
    path: "items",
    component: () => import("/app/apps/concierge/src/pages/issues/items.vue").then(m => m.default || m)
  },
  {
    name: "issues-shipment.spec",
    path: "shipment.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment.spec.js").then(m => m.default || m)
  },
  {
    name: shipmentIdbapodMXWMeta?.name,
    path: "shipment",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment.vue").then(m => m.default || m),
    children: [
  {
    name: "issues-shipment-details.spec",
    path: "details.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/details.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-shipment-details",
    path: "details",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/details.vue").then(m => m.default || m)
  },
  {
    name: "issues-shipment-index.spec",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/index.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-shipment",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/index.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "multiple-shipments-index.spec",
    path: "/multiple-shipments/index.spec",
    component: () => import("/app/apps/concierge/src/pages/multiple-shipments/index.spec.js").then(m => m.default || m)
  },
  {
    name: "multiple-shipments",
    path: "/multiple-shipments",
    component: () => import("/app/apps/concierge/src/pages/multiple-shipments/index.vue").then(m => m.default || m)
  },
  {
    name: "not-shipped.spec",
    path: "/not-shipped.spec",
    component: () => import("/app/apps/concierge/src/pages/not-shipped.spec.js").then(m => m.default || m)
  },
  {
    name: "not-shipped",
    path: "/not-shipped",
    component: () => import("/app/apps/concierge/src/pages/not-shipped.vue").then(m => m.default || m)
  },
  {
    name: "print-token",
    path: "/print/:token()",
    meta: _91token_93nggH91JHeqMeta || {},
    component: () => import("/app/apps/concierge/src/pages/print/[token].vue").then(m => m.default || m)
  },
  {
    name: "process.spec",
    path: "/process.spec",
    component: () => import("/app/apps/concierge/src/pages/process.spec.js").then(m => m.default || m)
  },
  {
    name: processmYDWhIdThyMeta?.name,
    path: "/process",
    component: () => import("/app/apps/concierge/src/pages/process.vue").then(m => m.default || m),
    children: [
  {
    name: "process-index.spec",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/process/index.spec.js").then(m => m.default || m)
  },
  {
    name: "process",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/process/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "resolution.spec",
    path: "/resolution.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution.spec.js").then(m => m.default || m)
  },
  {
    name: resolutionIN9pafKanIMeta?.name,
    path: "/resolution",
    component: () => import("/app/apps/concierge/src/pages/resolution.vue").then(m => m.default || m),
    children: [
  {
    name: "resolution-index.spec",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution/index.spec.js").then(m => m.default || m)
  },
  {
    name: "resolution",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/resolution/index.vue").then(m => m.default || m)
  },
  {
    name: "resolution-review.spec",
    path: "review.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution/review.spec.js").then(m => m.default || m)
  },
  {
    name: "resolution-review",
    path: "review",
    component: () => import("/app/apps/concierge/src/pages/resolution/review.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "return.spec",
    path: "/return.spec",
    component: () => import("/app/apps/concierge/src/pages/return.spec.js").then(m => m.default || m)
  },
  {
    name: "return",
    path: "/return",
    component: () => import("/app/apps/concierge/src/pages/return.vue").then(m => m.default || m)
  },
  {
    name: "sign-claimId",
    path: "/sign/:claimId()",
    meta: indexoGXiVJ5Z2SMeta || {},
    component: () => import("/app/apps/concierge/src/pages/sign/[claimId]/index.vue").then(m => m.default || m)
  },
  {
    name: "start.spec",
    path: "/start.spec",
    component: () => import("/app/apps/concierge/src/pages/start.spec.js").then(m => m.default || m)
  },
  {
    name: "start",
    path: "/start",
    component: () => import("/app/apps/concierge/src/pages/start.vue").then(m => m.default || m)
  },
  {
    name: "too-late.spec",
    path: "/too-late.spec",
    component: () => import("/app/apps/concierge/src/pages/too-late.spec.js").then(m => m.default || m)
  },
  {
    name: "too-late",
    path: "/too-late",
    component: () => import("/app/apps/concierge/src/pages/too-late.vue").then(m => m.default || m)
  },
  {
    name: "too-soon.spec",
    path: "/too-soon.spec",
    component: () => import("/app/apps/concierge/src/pages/too-soon.spec.js").then(m => m.default || m)
  },
  {
    name: "too-soon",
    path: "/too-soon",
    component: () => import("/app/apps/concierge/src/pages/too-soon.vue").then(m => m.default || m)
  },
  {
    name: "view-token-index.spec",
    path: "/view/:token()/index.spec",
    component: () => import("/app/apps/concierge/src/pages/view/[token]/index.spec.js").then(m => m.default || m)
  },
  {
    name: "view-token",
    path: "/view/:token()",
    meta: indexIy8gc4KnuvMeta || {},
    component: () => import("/app/apps/concierge/src/pages/view/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: "view-token-review",
    path: "/view/:token()/review",
    meta: reviewMFONAVXb9fMeta || {},
    component: () => import("/app/apps/concierge/src/pages/view/[token]/review.vue").then(m => m.default || m)
  }
]